













import Vue from 'vue'

export default Vue.extend({
  name: 'PaymentListItem',
  props: {
    basePoint: {
      type: Number,
      required: true
    },
    servicePoint: {
      type: Number,
      required: true
    },
    price: {
      type: Number,
      required: true
    },
    isFirst: {
      type: Boolean,
      default: false
    },
    isCampaign: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    classStr(): any {
      return {
        'is-first': this.isFirst,
        'is-campaign': this.isCampaign
      }
    },

    label(): string {
      return this.isFirst ? '初回限定' : this.isCampaign ? 'ポイント増量中' : ''
    }
  },
  methods: {
    async onClickByButton() {
      if (this.disabled) {
        return
      }
      this.$emit('buy')
    }
  }
})
